module.exports = __webpack_public_path__ + "img/Thunderstorm.6161a0cd.png";